  import React, { useEffect, useCallback, useState } from "react";
  import DownloadCarteiras from "./downloadCarteira";
  import VisualizarCarteirasMobile from "./VisualizarCarteirasMobile";
  import { requestData } from "../services/requests";
  import moment from "moment-timezone";
  import { useNavigate } from "react-router-dom";
  import { jwtDecode } from "jwt-decode";
  const {
    criarCarteiras,
    apiUrl,
    apiForImages,
  } = require("../services/requests");

  const NovaPaginaVisualizarCarteiras = () => {
    const largura =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));
    const url_atual = window.location.href;
    const id = url_atual.split("/")[4];
    const [carteira, setCarteira] = useState({});
    const [gestorResponsavel, setGestor] = useState({});

    const isTextTooLong = () => {
      const nameLength = carteira.name?.length || 0;
      const instituicaoLength = carteira.instituicaoEnsino?.length || 0;
      const cursoLength = carteira.curso?.length || 0;
      
      return nameLength > 30 || instituicaoLength > 30 || cursoLength > 30;
    };

    const MensagemWhatsAppAjuda =
      `https://api.whatsapp.com/send?phone=${gestorResponsavel.telefone}&text=Olá,` +
      `Gostaria de informações sobre a Carteira nº ${carteira.codigoUso}`;
    const mensagemRenovacao =
      `https://api.whatsapp.com/send?phone=${gestorResponsavel.telefone}&text=Olá,` +
      `Gostaria de solicitar a renovação da carteira nº ${carteira.codigoUso}`;
    const [componenteRenderizado, setComponenteRenderizado] = useState(false);
    const [renovacaoClicada, setRenovacaoClicada] = useState(false);

    const handleClickDownload = async () => {
      setComponenteRenderizado(true);
    };

    const handleClickRenovar = async (e) => {
      if (!user) {
        window.location.href = mensagemRenovacao;
      }
      setRenovacaoClicada(true);
      handleClick(e);
    };

    const handleClick = async (e) => {
      e.preventDefault();
      if (user) {
        try {
          const endpoint = "/carteiras/renovacao";
          await criarCarteiras(endpoint, {
            foto: carteira.foto,
            codigoUso: carteira.codigoUso,
            nome: carteira.name,
            instituicaoEnsino: carteira.instituicaoEnsino,
            curso: carteira.curso,
            cpf: carteira.cpf,
            rg: carteira.rg,
            dataNascimento: carteira.dataNascimento,
            email: carteira.email,
            telefone: carteira.telefone,
          });
          navigate("/painel");
        } catch (error) {
          console.log(error);
        }
      }
    };

    const getCarteira = useCallback(async () => {
      const carteiras = await requestData(`/carteiras/${id}`);
      setCarteira(carteiras);
      setGestor(carteiras.gestorResponsavel);
    }, [id]);

    useEffect(() => {
      getCarteira();
    }, [getCarteira]);

    return (
      <>
        {componenteRenderizado ? (
          <DownloadCarteiras
            carteira={carteira}
            setComponenteRenderizado={setComponenteRenderizado}
          />
        ) : largura >= 920 ? (
          carteira &&
          Object.keys(carteira).length > 0 && (
            <div>
              <header className="flex justify-around items-center h-28 bg-blue-600">
                <div className="flex items-center h-[80%]">
                  <img
                    src={`${apiForImages}/images/logo_unisc.png`}
                    alt="logo"
                    className="h-full"
                  />
                </div>
                <div className="flex items-center justify-around">
                  <a
                    href="/"
                    className="no-underline text-lg text-white font-neo-sans-pro font-bold mx-5"
                  >
                    VOLTAR
                  </a>
                  <a
                    href={MensagemWhatsAppAjuda}
                    className="no-underline text-lg text-white font-neo-sans-pro font-bold mx-5"
                  >
                    CONTATO
                  </a>
                  {carteira.status === "Cancelada" ||
                    carteira.status === "Expirada" ? (
                    <button
                      className="cursor-pointer mx-5 font-neo-sans-pro text-lg font-bold bg-red-500 border-none rounded-2xl text-white h-10 w-40 sm:h-8 sm:w-32"
                      onClick={handleClickRenovar}
                      disabled={renovacaoClicada}
                    >
                      {" "}
                      RENOVAR{" "}
                    </button>
                  ) : carteira.status === "Validada" ? (
                    <button
                      className="cursor-pointer mx-5 font-neo-sans-pro text-lg font-bold bg-yellow-500 border-none rounded-2xl text-white h-10 w-40 sm:h-8 sm:w-32"
                      onClick={(e) => handleClickDownload(e)}
                    >
                      DOWNLOAD
                    </button>
                  ) : (
                    carteira.status === "Recepcionada" && null
                  )}
                </div>
              </header>
              <section className="flex flex-col w-full">
                <div className="tittle">
                  <h1 className={`text-center font-neo-sans-pro font-bold my-20 text-[3vw]`}>
                    {" "}
                    DOCUMENTO NACIONAL DO ESTUDANTE (DNE){" "}
                  </h1>
                </div>
                <div className="flex mb-24">
                  <div
                    className="w-[70%] flex items-center justify-center relative ">
                    {" "}
                    <div className="flex items-center justify-center max-w-[50%] max-h-[500px]">
                      <img src={carteira.foto} alt="foto" className="w-[20vw] max-h-[500px]" />
                    </div>
                    <div className="ml-4 flex flex-col max-w-[50%] ">
                      <div className="flex flex-col">
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>
                          Nome:
                        </span>
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.name.toUpperCase()}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>
                          Instituição de ensino:
                        </span>
                        <span className={`my-0.5 font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.instituicaoEnsino.toUpperCase()}
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <span className={`font-neo-sans-pro mb-0 font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>
                          Curso:
                        </span>
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.curso.toUpperCase()}
                        </span>
                      </div>
                    <p className={`font-neo-sans-pro font-medium mb-1 ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>
                        Documentos:
                      </p>
                      <div>
                        <span className={`font-neo-sans-pro mb-2 font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>
                          CPF:{" "}
                        </span>
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.cpf}
                        </span>
                      </div>
                      <div>
                        <span className={`font-neo-sans-pro mb-2 font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>  
                          RG:{" "}
                        </span>
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.rg}
                        </span>
                      </div>
                      <div>
                        <span className={`font-neo-sans-pro mb-2 font-medium ${isTextTooLong() ? 'text-[1.2vw]' : 'text-[1.5vw]'}`}>  
                          Data Nasc:{" "}
                        </span>
                        <span className={`font-neo-sans-pro font-medium ${isTextTooLong() ? 'text-[1.5vw]' : 'text-[2vw]'}`}>
                          {carteira.dataNascimento}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center border-2 h-[18vw] border-black self-center">{""}</div>
                  <div className="flex w-3/10 flex-col items-center justify-center ml-16">
                    {carteira.status !== "Validada" ? null : (
                      <>
                        <div className="mb-12 flex items-center justify-center flex-col">
                          <div className="font-neo-sans-pro font-medium mt-2.5 mb-5 flex flex-col">
                            <span className="font-neo-sans-pro font-medium text-[2vw] text-center mb-0.5">
                              Código de uso
                            </span>
                            <span className="font-neo-sans-pro font-medium text-[2vw] text-center mb-0.5">
                              {carteira.codigoUso}
                            </span>
                          </div>
                          <div className="font-neo-sans-pro font-medium mt-2.5 mb-5 flex flex-col">
                            <span className="font-neo-sans-pro font-medium text-[2vw] text-center mb-0.5">
                              Validade
                            </span>
                            <span className="font-neo-sans-pro font-medium text-[2vw] text-center mb-0.5">
                              {moment
                                .utc(carteira.dataValidade)
                                .format("DD/MM/YYYY")}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {carteira.status === "Validada" ? (
                      <button className="self-center border-none pointer-events-none bg-green-200 font-neo-sans-pro font-medium h-16 w-7/10 p-2 rounded-2xl text-green-700 text-[1.5vw]">
                        Carteira Válida!
                      </button>
                    ) : carteira.status === "Cancelada" ||
                      carteira.status === "Expirada" ? (
                      <button className="self-center border-none pointer-events-none bg-red-300 font-neo-sans-pro font-medium h-16 w-7/10 p-2 rounded-2xl text-red-700 text-[1.5vw]">
                        Expirada!
                      </button>
                    ) : (
                      carteira.status === "Recepcionada" && (
                        <button className="border-none pointer-events-none bg-blue-300 font-neo-sans-pro font-medium h-16 w-7/11 p-2 rounded-2xl text-blue-600 text-[1.5vw]">
                          Recepcionada!
                        </button>
                      )
                    )}
                  </div>
                </div>
              </section>
              <footer className="bg-gray-200 flex flex-col items-center justify-center">
                <div className="mt-4">
                  <h3 className="font-inter font-medium text-[1.5vw] mb-1">
                    {" "}
                    UNISC ESTUDANTIL{" "}
                  </h3>
                </div>
                <div className="flex flex-col justify-center items-center w-1/4">
                  <span className="text-center font-inter font-medium text-[1.5vw] mb-1">
                    UNIAO ESTUDANTIL NACIONAL DE INCENTIVO SOCIAL E CULTURAL
                  </span>
                  <span className="text-center font-inter font-medium text-[1.5vw] mb-1">
                    CNPJ: 31.370.444/0001-42
                  </span>
                </div>
                <div className="mb-5">
                  <span className="font-inter font-medium text-[1.5vw]">
                    uniscestudantil@gmail.com
                  </span>
                </div>
              </footer>
            </div>
          )
        ) : (
          <VisualizarCarteirasMobile />
        )}
      </>
    );
  };

  export default NovaPaginaVisualizarCarteiras;
